<template>
  <v-bottom-navigation
    :value="activeBtn"
    color="primary"
    fixed
    grow
    shift>
    <v-btn
      value="trip"
      @click="movePage('trip');">
      <span>Trip</span>
      <v-icon>mdi-compass</v-icon>
    </v-btn>

    <v-btn
      value="history"
      @click="movePage('history');">
      <span>History</span>
      <v-icon>mdi-calendar-clock</v-icon>
    </v-btn>

    <v-btn
      value="gallery"
      @click="movePage('gallery');">
      <span>Gallery</span>
      <v-icon>mdi-postage-stamp</v-icon>
    </v-btn>
  </v-bottom-navigation>
</template>

<script>
import ga from '../libs/ga';

export default {
  data() {
    return {
      activeBtn: 'trip',
    };
  },
  watch: {
    '$route': function() {
      this.checkActiveBtn();
    },
    '$store.state.errorCount': function() {
      if (this.$store.state.errorCount === 3) {
        this.$router.push('/');
        this.$store.dispatch('showSnackbar', {
          ga: this.$ga,
          snackbar: {
            color: 'error',
            text: 'エラーが続きました。再ログインをしてください',
          },
        });
      }
    },
  },
  created: function() {
    this.checkActiveBtn();
  },
  methods: {
    movePage: function(path) {
      ga.bottomMenu.move(this.$ga, path);

      this.activeBtn = path;
      this.$store.commit('changeTransitionMode', 'fade');
      this.$router.push(`/${path}`);
    },
    checkActiveBtn: function() {
      const path = location.href.split('/')[3];

      // アクティブなボタンを判定する
      if (path === 'memory' || path === 'memories') this.activeBtn = 'trip';
      else if (path === 'terms' || path === 'privacy') this.activeBtn = this.activeBtn;
      else this.activeBtn = path;
    },
  },
};
</script>
